(function(){
  'use strict';

  /* Il capitolo è diviso in tre sezioni che convivono nella stessa pagina:
     questo file gira una volta sola e si occupa di tutti i root che trova.
     La guardia serve perché ogni sezione include lo stesso asset e un
     <script src> duplicato verrebbe eseguito due volte. */
  if(window.__tgeBooted) return;
  window.__tgeBooted = true;
  var DESK = '(min-width: 951px)';

  /* ============================================================
     SPLIT — tre livelli. Gli elementi figli (<em> oro) non vengono smontati:
     si entra dentro e si divide il loro testo, così l'accento resta accento.
     Gli elementi senza testo (il float del rientro) restano dove sono.
     ============================================================ */
  function isTextEl(n){ return n.nodeType === 1 && n.textContent.trim().length > 0; }

  function wrapWords(el, perChar){
    var out = [];
    (function walk(parent){
      Array.prototype.slice.call(parent.childNodes).forEach(function(node){
        if(node.nodeType === 3){
          var parts = node.textContent.split(/(\s+)/), frag = document.createDocumentFragment();
          parts.forEach(function(p){
            if(!p) return;
            if(/^\s+$/.test(p)){ frag.appendChild(document.createTextNode(' ')); return; }
            var w = document.createElement('span');
            w.className = 'tge-word';
            if(perChar){
              p.split('').forEach(function(ch){
                var c = document.createElement('span');
                c.className = 'tge-char'; c.textContent = ch; w.appendChild(c);
              });
            } else { w.textContent = p; }
            frag.appendChild(w); out.push(w);
          });
          parent.replaceChild(frag, node);
        } else if(isTextEl(node)){ walk(node); }
      });
    })(el);
    return out;
  }

  /* Righe: si divide per parole, si leggono gli offsetTop, si raggruppa.
     È l'unico punto del file che legge il layout — una volta, e di nuovo
     solo al resize. */
  function splitLines(el){
    wrapWords(el, false);
    var words = el.querySelectorAll('.tge-word');
    if(!words.length) return [];
    var lines = [], cur = [], top = null;
    Array.prototype.forEach.call(words, function(w){
      var t = Math.round(w.offsetTop);
      if(top === null || Math.abs(t - top) < 4){ cur.push(w); }
      else { lines.push(cur); cur = [w]; }
      if(top === null || t > top) top = t;
    });
    if(cur.length) lines.push(cur);
    var inners = [];
    lines.forEach(function(group){
      var mask = document.createElement('span'); mask.className = 'tge-linemask';
      var inner = document.createElement('span'); inner.className = 'tge-lineinner';
      group[0].parentNode.insertBefore(mask, group[0]);
      group.forEach(function(w, i){ if(i) inner.appendChild(document.createTextNode(' ')); inner.appendChild(w); });
      mask.appendChild(inner); inners.push(inner);
    });
    return inners;
  }

  function prepare(el, kind){
    if(el.__tgeHTML == null){
      el.__tgeHTML = el.innerHTML;
      el.__tgeText = el.textContent.replace(/\s+/g,' ').trim();
    } else { el.innerHTML = el.__tgeHTML; }

    var pieces;
    if(kind === 'p'){ pieces = splitLines(el); }
    else { wrapWords(el, true); pieces = el.querySelectorAll('.tge-char'); }

    if(/^H[1-6]$/.test(el.tagName)){
      /* Un heading accetta aria-label: il ruolo lo supporta. */
      el.setAttribute('aria-label', el.__tgeText);
    } else if(!el.querySelector('.tge-sr')){
      /* Su <p>/<span> aria-label non ha un ruolo che lo supporti e molti
         screen reader lo ignorano: serve testo vero, nascosto alla vista. */
      var sr = document.createElement('span');
      sr.className = 'tge-sr'; sr.textContent = el.__tgeText;
      el.appendChild(sr);
    }
    Array.prototype.forEach.call(el.querySelectorAll('.tge-word,.tge-char,.tge-linemask,.tge-lineinner'),
      function(n){ n.setAttribute('aria-hidden','true'); });
    el.style.visibility = 'visible';
    return pieces;
  }

  /* ============================================================ */

  function bootAll(){
    document.querySelectorAll('[data-tge-root]').forEach(boot);
  }

  function boot(root){
    if(!root || root.__tgeOn) return;
    root.__tgeOn = true;

    var reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
    var gsapOK  = typeof window.gsap !== 'undefined' && typeof window.ScrollTrigger !== 'undefined';

    /* Navigazione e contenuto restano vivi senza GSAP e con reduced-motion:
       il rail, le schede che si aprono, le tab, il torna-su, il tema colore. */
    initRail(root);
    initPeople(root);
    initTabs(root);
    initToTop(root);
    initThemeBroadcast(root, gsapOK && !reduced);

    if(!gsapOK || reduced){
      /* Senza schermo pinnato le slide non possono impilarsi: restano in
         colonna, tutte visibili (regola .tge-slides:not(.is-ready)). */
      return;
    }

    gsap.registerPlugin(ScrollTrigger);
    root.classList.add('js-flicker');
    /* Autorizza gli schermi pinnati: senza, le aree restano alte quanto il
       contenuto e il capitolo si legge come un documento normale. */
    root.classList.add('js-motion');

    try{
      if(window.__lenis && !window.__tgeLenisWired){
        window.__lenis.on('scroll', ScrollTrigger.update);
        window.__tgeLenisWired = true;
      }
    }catch(e){}

    var ctx = gsap.context(function(){
      initReveals();
      initImages();
      initRing();
      initTracking();
      initOrnaments();
      initYear();
      initMarquee();
      initSlides();
      initJourney();
      initCurtain();
      initTableWords();
    }, root);

    if(document.fonts && document.fonts.ready){ document.fonts.ready.then(resplit); }
    window.addEventListener('load', function(){ ScrollTrigger.refresh(); }, {once:true});

    /* Il taglio in righe dipende dalla larghezza: al resize va rifatto,
       altrimenti le maschere restano tarate sulle righe di prima e tagliano
       il testo a metà. Debounce, perché ogni ricalcolo legge il layout. */
    var rt = null;
    window.addEventListener('resize', function(){ clearTimeout(rt); rt = setTimeout(resplit, 220); });

    function resplit(){
      root.querySelectorAll('[data-tge-reveal="p"]').forEach(function(el){
        if(el.__tgeST) el.__tgeST.kill();
        el.__tgeST = revealLines(el, prepare(el, 'p'));
      });
      /* L'anello si misura sul font renderizzato e sulla larghezza: va
         rifatto quando cambia l'uno o l'altra, o resta tarato sul fallback. */
      initRing();
      ScrollTrigger.refresh();
    }

    document.addEventListener('shopify:section:unload', function(e){
      if(e.target && e.target.contains(root)){ try{ ctx.revert(); }catch(err){} }
    });

    /* ---------- REVEAL ----------
       h    → caratteri che salgono e sfumano
       flip → caratteri che ruotano su Y (solo le schede-persona)
       p    → righe che salgono dentro la propria maschera
       line → filetti che si disegnano in scaleX
       ctn  → contenitori che salgono e sfumano interi                     */
    function revealLines(el, inners){
      if(!inners.length) return null;
      var tw = gsap.fromTo(inners, {yPercent: 110}, {
        yPercent: 0, ease: 'none', stagger: {amount: Math.min(0.35, inners.length * 0.07)},
        scrollTrigger: { trigger: el, start: 'top 94%', end: 'top 52%', scrub: 0.6 }
      });
      return tw.scrollTrigger;
    }

    function initReveals(){
      root.querySelectorAll('[data-tge-reveal="h"]').forEach(function(h){
        if(!h.textContent.trim()) return;
        var chars = prepare(h, 'h');
        if(!chars.length) return;

        /* L'apertura del capitolo entra al caricamento, non allo scroll: un
           titolo che per essere letto richiede di scorrere non è un titolo.
           È l'unica animazione a tempo proprio — tutte le altre le detta
           la rotella. */
        if(h.closest('.tge-open')){
          gsap.fromTo(chars, {yPercent: 108, opacity: 0},
            {yPercent: 0, opacity: 1, duration: 1.1, ease: 'expo.out', stagger: 0.012, delay: 0.1});
          return;
        }
        gsap.fromTo(chars, {yPercent: 108, opacity: 0}, {
          yPercent: 0, opacity: 1, ease: 'none',
          stagger: {amount: Math.min(0.45, chars.length * 0.012)},
          scrollTrigger: { trigger: h, start: 'top 92%', end: 'top 46%', scrub: 0.6 }
        });
      });

      /* L'unico reveal 3D: i nomi delle schede ruotano su Y. */
      root.querySelectorAll('[data-tge-reveal="flip"]').forEach(function(el){
        if(!el.textContent.trim()) return;
        var chars = prepare(el, 'h');
        if(!chars.length) return;
        gsap.fromTo(chars, {rotateY: 90, yPercent: 50, opacity: 0}, {
          rotateY: 0, yPercent: 0, opacity: 1, ease: 'none',
          stagger: {amount: Math.min(0.4, chars.length * 0.02)},
          scrollTrigger: { trigger: el, start: 'top 94%', end: 'top 56%', scrub: 0.6 }
        });
      });

      root.querySelectorAll('[data-tge-reveal="p"]').forEach(function(p){
        if(!p.textContent.trim()) return;
        p.__tgeST = revealLines(p, prepare(p, 'p'));
      });

      root.querySelectorAll('[data-tge-reveal="line"]').forEach(function(l){
        gsap.fromTo(l, {scaleX: 0}, { scaleX: 1, ease: 'none',
          scrollTrigger: { trigger: l, start: 'top 96%', end: 'top 70%', scrub: 0.5 } });
      });

      /* Filetti verticali: si disegnano dall'alto. */
      root.querySelectorAll('[data-tge-reveal="draw"]').forEach(function(l){
        gsap.fromTo(l, {clipPath: 'inset(0% 0% 100% 0%)'}, {
          clipPath: 'inset(0% 0% 0% 0%)', ease: 'none',
          scrollTrigger: { trigger: l, start: 'top 94%', end: 'bottom 64%', scrub: 0.6 }
        });
      });

      root.querySelectorAll('[data-tge-reveal="ctn"]').forEach(function(c){
        gsap.fromTo(c, {y: 18, opacity: 0}, { y: 0, opacity: 1, ease: 'none',
          scrollTrigger: { trigger: c, start: 'top 96%', end: 'top 74%', scrub: 0.5 } });
      });
    }

    /* ---------- LE ANIMAZIONI DELLE FOTO ----------
       Quattro comportamenti distinti, con i valori misurati sul riferimento
       (dove data-parallax non è un numero ma un tipo):

         in        scala .75 → 1, y −20% → 0, opacità 0 → 1
         through   y −15% → +15%   (immagine dentro la maschera)
         ctn-down  y −10% → +10%   (contenitori e decori)
         ctn-up    y +10% → −10%

       Le foto di contenuto NON vanno in parallasse: entrano in campo
       crescendo. La parallasse vera è solo per le immagini a tutta pagina.

       ease:'none' ovunque: la curva la dà lo scroll. force3D promuove il
       livello sul compositore — è il translate3d(0,0,10px) del riferimento. */
    function initImages(){
      root.querySelectorAll('[data-tge-img]').forEach(function(el){
        var type = el.getAttribute('data-tge-img');
        var area = el.closest('.tge-area');

        if(type === 'in'){
          /* Dentro uno schermo pinnato la maschera non si muove mai rispetto
             al viewport: un trigger su di lei non partirebbe. Lì l'ancora è
             il contenitore alto, e la composizione finisce di arrivare
             esattamente quando lo schermo si inchioda. */
          var st = el.closest('.tge-screen')
            ? { trigger: area, start: 'top bottom', end: 'top top', scrub: 0.6 }
            : { trigger: el,   start: 'top 88%',    end: 'top 42%', scrub: 0.6 };
          gsap.fromTo(el, {scale: 0.75, yPercent: -20, opacity: 0},
            {scale: 1, yPercent: 0, opacity: 1, ease: 'none', force3D: true, scrollTrigger: st});
          return;
        }

        if(type === 'through'){
          var imgs = el.querySelectorAll('img');
          if(!imgs.length) return;
          gsap.fromTo(imgs, {yPercent: -15}, {
            yPercent: 15, ease: 'none', force3D: true,
            scrollTrigger: { trigger: area || el, start: 'top bottom', end: 'bottom top', scrub: 0.5 }
          });
          return;
        }

        if(type === 'ctn-down' || type === 'ctn-up'){
          var from = (type === 'ctn-down') ? -10 : 10;
          gsap.fromTo(el, {yPercent: from}, {
            yPercent: -from, ease: 'none', force3D: true,
            scrollTrigger: { trigger: el.closest('.tge-act') || el, start: 'top bottom', end: 'bottom top', scrub: 0.5 }
          });
        }
      });
    }

    /* ---------- ANELLO DI TESTO ----------
       Non ruota — si APRE. Il riferimento anima word-spacing: la frase parte
       compatta in cima all'anello e si distribuisce lungo la circonferenza.
       È il gesto dei capoletti spaziati, portato su un cerchio.

       Il limite di apertura NON può essere un numero fisso. Il testo è
       ancorato al 25% del percorso con text-anchor:middle, quindi cresce
       simmetricamente: se supera il 50% della circonferenza sfora l'inizio
       del percorso e SVG taglia via le prime lettere — con una frase da
       cinque parole si legge "REE THINGS" invece di "THREE THINGS".
       Qui lo spazio massimo si calcola dalla lunghezza reale del testo e da
       quella del percorso, quindi regge qualunque frase Peppe ci scriva. */
    function initRing(){
      root.querySelectorAll('[data-tge-ringtext]').forEach(function(t){
        var tp = t.querySelector('textPath');
        var path = tp && root.querySelector(tp.getAttribute('href') || tp.getAttribute('xlink:href'));
        if(!path) return;

        var words = (t.textContent.trim().split(/\s+/).length) - 1;
        if(words < 1) return;

        var start = 0;
        var maxWs = start;
        try{
          var L = path.getTotalLength();
          var off = parseFloat(tp.getAttribute('startOffset')) / 100 || 0.25;

          /* Rete di sicurezza: oltre questo il testo sfora l'inizio del
             percorso e SVG taglia via le prime lettere. Non è l'obiettivo. */
          var hardMax = 2 * Math.min(off, 1 - off) * L * 0.94;

          /* Obiettivo vero: il 38% della circonferenza, misurato sul
             riferimento. Resta un arco raccolto in cima, non un giro. */
          var target = L * 0.38;

          t.setAttribute('word-spacing', 0);
          var bare = t.getComputedTextLength();
          maxWs = Math.floor((Math.min(target, hardMax) - bare) / words);
          t.setAttribute('word-spacing', start);
        }catch(e){ return; }

        if(t.__tgeTw){ t.__tgeTw.scrollTrigger && t.__tgeTw.scrollTrigger.kill(); t.__tgeTw.kill(); t.__tgeTw = null; }
        if(maxWs <= 8) return;   /* la frase riempie già l'arco: non c'è niente da aprire */

        t.__tgeTw = gsap.fromTo(t, {attr: {'word-spacing': start}}, {
          attr: {'word-spacing': maxWs}, ease: 'none',
          scrollTrigger: { trigger: t.closest('.tge-act'), start: 'top bottom', end: 'bottom top', scrub: 0.5 }
        });
      });
    }

    /* ---------- CAPOLETTI CHE SI APRONO ----------
       Il riferimento allarga il tracking allo scroll. Animare letter-spacing
       fa ricalcolare il layout a ogni frame: divido in lettere e muovo ognuna
       con `x`, che resta sul compositore. Lo scarto è proporzionale alla
       distanza dal centro, così la parola si apre dai due lati. */
    function initTracking(){
      root.querySelectorAll('[data-tge-track]').forEach(function(el){
        var text = el.textContent.trim();
        if(!text) return;
        el.innerHTML = '';
        var sr = document.createElement('span');
        sr.className = 'tge-sr'; sr.textContent = text; el.appendChild(sr);
        var chars = [];
        text.split('').forEach(function(ch){
          var s = document.createElement('span');
          s.style.display = 'inline-block'; s.setAttribute('aria-hidden','true');
          /* Uno spazio normale dentro un inline-block collassa a larghezza
             zero: "Melito Irpino" diventava "MELITOIRPINO". Serve lo spazio
             unificatore, che non viene collassato. */
          s.textContent = (ch === ' ') ? ' ' : ch;
          el.appendChild(s); chars.push(s);
        });
        var mid = (chars.length - 1) / 2;
        var area = el.closest('.tge-area') || el.closest('.tge-act');
        /* 28/09/2026 — Lo scarto per lettera era fisso a 6px. Su telefono il
           tracking vale ~4px: a inizio corsa le lettere si accavallavano
           ("MELITOIRPINO"). Ora lo scarto è metà del tracking reale, con
           tetto a 6px: su desktop non cambia nulla, su telefono le lettere
           si avvicinano senza toccarsi mai. */
        var ls = parseFloat(getComputedStyle(el).letterSpacing) || 0;
        var amp = Math.max(1, Math.min(6, ls * 0.5));
        gsap.fromTo(chars, { x: function(i){ return (i - mid) * -amp; } }, {
          x: function(i){ return (i - mid) * amp; }, ease: 'none',
          scrollTrigger: { trigger: area, start: 'top top', end: 'bottom top', scrub: 0.4 }
        });
      });
    }

    /* ---------- ORNAMENTI ----------
       Corsa volutamente più lunga della sezione (top 125% → bottom -25%):
       cominciano a girare prima di entrare e continuano dopo essere usciti,
       così non si vedono mai né partire né fermarsi. L'orientamento di base
       sta in CSS (proprietà `rotate`), qui si anima solo la deriva. */
    function initOrnaments(){
      root.querySelectorAll('[data-tge-rotate]').forEach(function(o){
        var amp = parseFloat(o.getAttribute('data-tge-rotate')) || 20;
        gsap.fromTo(o, {rotation: -amp}, { rotation: amp, ease: 'none',
          scrollTrigger: { trigger: o.closest('.tge-act') || o, start: 'top 125%', end: 'bottom -25%', scrub: 0.5 } });
      });
    }

    function initYear(){
      var y = root.querySelector('[data-tge-year]');
      if(!y) return;
      gsap.fromTo(y, {scale: 0.92}, { scale: 1, ease: 'none',
        scrollTrigger: { trigger: y.closest('.tge-act'), start: 'top bottom', end: 'center center', scrub: 0.5 } });
    }

    /* ---------- MARQUEE ----------
       Il nastro contiene due copie della lista: si trasla del 50% e riparte,
       quindi il salto non si vede. La velocità è modulata dalla velocità di
       scroll — è il dettaglio che lega il nastro alla rotella invece di
       farlo scorrere per conto suo. */
    function initMarquee(){
      root.querySelectorAll('[data-tge-marquee]').forEach(function(track){
        var tw = gsap.to(track, {xPercent: -50, duration: 26, ease: 'none', repeat: -1});
        var boost = null;
        ScrollTrigger.create({
          trigger: track.closest('.tge-act'), start: 'top bottom', end: 'bottom top',
          onUpdate: function(self){
            tw.timeScale(Math.min(3.2, 1 + Math.abs(self.getVelocity()) / 1400));
            clearTimeout(boost);
            boost = setTimeout(function(){ gsap.to(tw, {timeScale: 1, duration: .8, overwrite: true}); }, 90);
          },
          onToggle: function(self){ self.isActive ? tw.play() : tw.pause(); }  /* fermo fuori schermo */
        });
      });
    }

    /* ---------- SEZIONI A SLIDE ----------
       Il contenitore è alto (n+1) schermate e lo schermo dentro è sticky:
       la corsa verticale diventa avanzamento fra le slide, senza pin di GSAP.
       Le slide sfumano l'una nell'altra; il progresso alimenta il filetto. */
    function initSlides(){
      var mm = gsap.matchMedia();
      root.querySelectorAll('[data-tge-slides]').forEach(function(area){
        var slides = area.querySelectorAll('.tge-slide');
        if(slides.length < 1) return;
        var now  = area.querySelector('[data-tge-slides-now]');
        var fill = area.querySelector('[data-tge-slides-fill]');

        mm.add(DESK, function(){
          var last = -1;
          area.classList.add('is-ready');
          ScrollTrigger.create({
            trigger: area, start: 'top top', end: 'bottom bottom', scrub: true,
            onUpdate: function(self){
              var p = self.progress;
              if(fill) fill.style.transform = 'scaleX(' + p + ')';
              var i = Math.min(slides.length - 1, Math.floor(p * slides.length));
              if(i === last) return;
              last = i;
              slides.forEach(function(s, k){ s.classList.toggle('is-on', k === i); });
              if(now) now.textContent = ('0' + (i + 1)).slice(-2);
            }
          });
          /* Uscendo dal desktop si torna alla colonna: senza questo, le slide
             resterebbero assolute e invisibili dopo una rotazione di schermo. */
          return function(){ area.classList.remove('is-ready'); };
        });
      });
    }

    /* ---------- CORSA ORIZZONTALE ----------
       Lo scroll verticale del contenitore alto trascina il track di lato.
       La distanza si ricalcola a ogni refresh: se cambia la larghezza, o si
       caricano le immagini, la corsa deve restare esatta o l'ultima tappa
       resta fuori. Solo desktop: su telefono il track è una colonna. */
    function initJourney(){
      root.querySelectorAll('[data-tge-journey]').forEach(function(track){
        var area = track.closest('.tge-area');
        var view = track.parentElement;
        if(!area) return;
        var mm = gsap.matchMedia();
        mm.add(DESK, function(){
          gsap.to(track, {
            x: function(){ return -Math.max(0, track.scrollWidth - view.clientWidth); },
            ease: 'none',
            scrollTrigger: { trigger: area, start: 'top top', end: 'bottom bottom',
                             scrub: 0.4, invalidateOnRefresh: true }
          });
        });
      });
    }

    /* ---------- TENDA ----------
       Due metà che scorrono ai lati scoprendo quello che c'è dietro. */
    function initCurtain(){
      root.querySelectorAll('[data-tge-curtain]').forEach(function(c){
        var halves = c.children;
        gsap.fromTo(halves[0], {xPercent: 0}, { xPercent: -101, ease: 'none',
          scrollTrigger: { trigger: c.closest('.tge-act'), start: 'top 85%', end: 'center 58%', scrub: 0.6 } });
        gsap.fromTo(halves[1], {xPercent: 0}, { xPercent: 101, ease: 'none',
          scrollTrigger: { trigger: c.closest('.tge-act'), start: 'top 85%', end: 'center 58%', scrub: 0.6 } });
      });
    }

    /* ---------- PAROLE DELLA TAVOLA ----------
       Una alla volta, sfalsate: sono un elenco che si pronuncia, non un
       blocco che appare. */
    function initTableWords(){
      var words = root.querySelectorAll('[data-tge-word-step]');
      if(!words.length) return;
      /* 28/09/2026 — La firma in corsivo ("la firma") entra per ultima,
         nella stessa sequenza delle parole: prima restava ferma mentre
         "Orto." saliva da sotto, e le due righe si attraversavano. */
      var seq = Array.prototype.slice.call(words);
      var sig = words[0].closest('.tge-table__screen');
      sig = sig && sig.querySelector('.tge-script');
      if(sig) seq.push(sig);
      words = seq;
      gsap.fromTo(words, {yPercent: 40, opacity: 0.12}, {
        yPercent: 0, opacity: 1, ease: 'none', stagger: {amount: 0.5},
        scrollTrigger: { trigger: words[0].closest('.tge-area') || words[0].closest('.tge-act'),
                         start: 'top 70%', end: 'center center', scrub: 0.6 }
      });
    }
  }

  /* ---------- RAIL + PAGINAZIONE ----------
     Contenitore con overflow-x proprio: muove scrollLeft, non lo scroll della
     finestra, quindi non litiga con Lenis né con il drag della scena
     orizzontale della home. Le frecce sono <button> veri: tastiera e screen
     reader ci arrivano, il trascinamento è in più. */
  function initRail(root){
    var rail = root.querySelector('[data-tge-rail]');
    if(!rail) return;
    var cards = rail.querySelectorAll('.tge-card');
    var fill  = root.querySelector('[data-tge-pag-fill]');
    var now   = root.querySelector('[data-tge-pag-now]');
    var prev  = root.querySelector('[data-tge-pag-prev]');
    var next  = root.querySelector('[data-tge-pag-next]');

    function step(){ return cards.length < 2 ? rail.clientWidth : cards[1].offsetLeft - cards[0].offsetLeft; }
    function maxScroll(){ return Math.max(0, rail.scrollWidth - rail.clientWidth); }

    function sync(){
      var max = maxScroll(), p = max > 0 ? rail.scrollLeft / max : 0;
      if(fill) fill.style.transform = 'scaleX(' + p + ')';
      /* L'indice segue la stessa corsa del filetto: 01 a inizio, totale a
         fine, sempre. Contare la scheda più a sinistra non arriverebbe mai
         all'ultima. */
      if(now) now.textContent = ('0' + (1 + Math.round(p * (cards.length - 1)))).slice(-2);
      if(prev) prev.disabled = rail.scrollLeft <= 1;
      if(next) next.disabled = rail.scrollLeft >= max - 1;
    }
    rail.addEventListener('scroll', sync, {passive:true});
    window.addEventListener('resize', sync);
    sync();

    if(prev) prev.addEventListener('click', function(){ rail.scrollLeft -= step(); });
    if(next) next.addEventListener('click', function(){ rail.scrollLeft += step(); });

    /* Soglia di 5px: sotto, un click resta un click. Su touch vale lo swipe
       nativo, migliore di qualunque emulazione. */
    var down = false, x0 = 0, left0 = 0, moved = 0;
    rail.addEventListener('pointerdown', function(e){
      if(e.pointerType === 'touch') return;
      down = true; moved = 0; x0 = e.clientX; left0 = rail.scrollLeft;
      rail.classList.add('is-dragging');
    });
    rail.addEventListener('pointermove', function(e){
      if(!down) return;
      var dx = e.clientX - x0;
      moved = Math.max(moved, Math.abs(dx));
      if(moved < 5) return;
      rail.scrollLeft = left0 - dx;
    });
    function end(){ if(!down) return; down = false; rail.classList.remove('is-dragging');
      setTimeout(function(){ moved = 0; }, 0); }
    ['pointerup','pointercancel','pointerleave'].forEach(function(ev){ rail.addEventListener(ev, end); });
    rail.addEventListener('click', function(e){ if(moved > 6){ e.preventDefault(); e.stopPropagation(); } }, true);
    rail.addEventListener('dragstart', function(e){ e.preventDefault(); });
  }

  /* ---------- SCHEDE CHE SI APRONO ----------
     grid-template-rows 0fr→1fr: apertura fluida senza misurare l'altezza in
     JS, quindi niente da ricalcolare al resize. Una sola aperta per volta. */
  function initPeople(root){
    var btns = root.querySelectorAll('.tge-person__btn');
    if(!btns.length) return;
    btns.forEach(function(b){
      b.addEventListener('click', function(){
        var open = b.getAttribute('aria-expanded') === 'true';
        btns.forEach(function(o){ o.setAttribute('aria-expanded','false'); });
        b.setAttribute('aria-expanded', open ? 'false' : 'true');
        if(!open && window.ScrollTrigger){
          /* L'apertura cambia l'altezza della pagina: senza refresh gli
             start/end di tutto ciò che sta sotto restano tarati sul layout
             di prima. Dopo la transizione, non durante. */
          setTimeout(function(){ try{ ScrollTrigger.refresh(); }catch(e){} }, 560);
        }
      });
    });
  }

  /* ---------- TAB DELL'OVERTURA ----------
     Nel riferimento cambiano l'immagine dell'eroe (giorno/notte). Qui fanno
     lo stesso se c'è una seconda immagine; se non c'è, restano due etichette
     e la tab non viene mostrata come interattiva a vuoto. */
  function initTabs(root){
    var wrap = root.querySelector('[data-tge-tabs]');
    if(!wrap) return;
    var tabs = wrap.querySelectorAll('[data-tge-tab]');
    var imgs = root.querySelectorAll('[data-tge-openimg]');
    tabs.forEach(function(t){
      t.addEventListener('click', function(){
        tabs.forEach(function(o){ o.setAttribute('aria-pressed','false'); });
        t.setAttribute('aria-pressed','true');
        var n = t.getAttribute('data-tge-tab');
        imgs.forEach(function(im){
          var on = im.getAttribute('data-tge-openimg') === n;
          im.style.opacity = on ? '1' : '0';
        });
      });
    });
  }

  function initToTop(root){
    var b = root.querySelector('[data-tge-totop]');
    if(!b) return;
    b.addEventListener('click', function(){
      var top = root.getBoundingClientRect().top + (window.scrollY || window.pageYOffset || 0);
      if(window.__lenis && window.__lenis.scrollTo){ try{ window.__lenis.scrollTo(top); return; }catch(e){} }
      window.scrollTo({top: top, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
    });
  }

  /* ---------- TEMA COLORE ANNUNCIATO ALLA PAGINA ----------
     Ogni atto scrive il proprio tema su <html data-tge-theme> ed emette un
     evento. Serve a far cambiare colore agli elementi fissi che vivono fuori
     dalla sezione — header e cursore del tema — senza che questa sezione
     debba conoscerli. Se nessuno ascolta, non succede nulla. */
  function initThemeBroadcast(root, withST){
    var acts = root.querySelectorAll('[data-tge-theme]');
    if(!acts.length) return;
    function set(t){
      if(document.documentElement.getAttribute('data-tge-theme') === t) return;
      document.documentElement.setAttribute('data-tge-theme', t);
      document.dispatchEvent(new CustomEvent('tge:theme', {detail: {theme: t}}));
    }
    if(withST){
      acts.forEach(function(a){
        var t = a.getAttribute('data-tge-theme');
        ScrollTrigger.create({ trigger: a, start: 'top 50%', end: 'bottom 50%',
          onEnter: function(){ set(t); }, onEnterBack: function(){ set(t); } });
      });
      return;
    }
    if(!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function(en){
      en.forEach(function(e){ if(e.isIntersecting) set(e.target.getAttribute('data-tge-theme')); });
    }, {rootMargin: '-50% 0px -50% 0px'});
    acts.forEach(function(a){ io.observe(a); });
  }

  if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', bootAll); }
  else { bootAll(); }
  /* Nell'editor una sezione ricaricata è un root nuovo: lo si avvia da solo. */
  document.addEventListener('shopify:section:load', function(e){
    if(e.target) e.target.querySelectorAll('[data-tge-root]').forEach(boot);
  });
})();
